import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import UserTermsAndConditionsForm from '../../components/UserTermsAndConditionsForm';
import LoadingModal from '../../components/LoadingModal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';

class UserTermsAndConditions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    onSubmit(data) {
        this.setState({
            loading: true,
        });

        AuthService.processUserTerms(data)
            .then(response => {
                this.setState({
                    loading: false,
                });

                if (response.success) {
                    this.props.history.push('/register/thank-you');
                } else {
                    this.props.history.push('/register/thank-you?manual=true');
                }
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    componentDidMount() {
        //this is a new session, remove cookie;

        this.props.setStep('TERMS');
        AuthService.getLinks().then(response => {
            this.setState({
                terms: response.terms,
                privacy: response.privacy,
            });
        });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('PROMO CODE & USER TERMS AND CONDITIONS')}</h3>

                    <div className="f-container flex-grow-1">
                        <UserTermsAndConditionsForm
                            enabledCallback={enabled => {
                                this.setState({ isEnabled: enabled });
                            }}
                            ref={ref => {
                                this._form = ref;
                            }}
                            terms={this.state.terms}
                            privacy={this.state.privacy}
                            onSubmit={this.onSubmit.bind(this)}
                        />
                    </div>

                    <div className="d-flex flex-row mt-auto mb-1-5rem">
                        <button className="btn btn-primary btn-block mr-0 ml-auto" onClick={() => this._form.submit()}>
                            {window.VULOG_TRANSLATE('Confirm')}
                            <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                        </button>
                        {/*<button className="btn btn-primary btn-block"><i className="material-icons va-middle reg">keyboard_arrow_left</i>Back</button>*/}
                    </div>
                    <LoadingModal loading={this.state.loading} />
                </div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(UserTermsAndConditions));
